module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 0
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11